// extracted by mini-css-extract-plugin
export default {"Pill":"FilteredPills_Pill__eAHVY","FilteredPillsWrapper":"FilteredPills_FilteredPillsWrapper__5fs4X","ClearAllPill":"FilteredPills_ClearAllPill__nit3R"};